export enum MessageDeliveryType {
  Email,
  Text,
}

export enum MessageFrequencyTypes {
  None = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export enum MessageRecurranceTypes {
  None = 0,
  CampaignReport = 1,
}
